/**
 * The once-per-flow-mount gate behind the embed's size events, module-level like `flowLoadedGate`: the property
 * screen remounts when the browser goes back to it within the same flow. The flow shell resets it when it unmounts.
 */

let announced = false

/** Called by the flow shell on unmount, so the next flow reports its size again. */
export const resetSizeAnnouncementGate = (): void => {
  announced = false
}

/** True for the first call per flow mount; every later one gets false. */
export const claimSizeAnnouncement = (): boolean => {
  if (announced) return false
  announced = true
  return true
}
